<div
  class="symbol symbol-circle overflow-hidden"
  [ngClass]="{
    'symbol-40px': size() === 'sm',
    'symbol-100px': size() === 'xl',
  }"
>
  @if (imageUrl()) {
    <img [src]="imageUrl()" [alt]="userName()" class="symbol-label" />
  } @else {
    <div
      class="symbol-label fs-3"
      [classList]="colorClass"
      [ngClass]="{
        'fs-3': size() === 'sm',
        'fs-1': size() === 'xl',
        colorClass: true,
      }"
    >
      {{ firstLetter }}
    </div>
  }
</div>
